import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { buyRespRootQuery } from '../../queries/buyRespRoot.js';
import { BuyRespLayout } from '../../buy/BuyRespLayout.jsx';
import { createEntry } from '../createEntry.jsx';
import { datadog, initSharedDatadogRum, sbTypes } from 'dibs-datadog/exports/datadog.ts';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes.ts';
import { setDatadogABTestValues } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

import { defaultReducers, actionSanitizer } from '../../reducers/reducerUtils.js';
import { sbSharedReducers } from '../../reducers/sbSharedReducers.js';
const options = {
    reducers: {
        ...defaultReducers,
        ...sbSharedReducers,
    },
    actionSanitizer,
};

datadog.load().then(dd => {
    initSharedDatadogRum(dd, {
        device: 'resp',
        page: PAGE_TYPE.BROWSE,
        pageSubType: sbTypes.buy,
    });
    setDatadogABTestValues();
});

initializeDBL(options).then(({ store }) => {
    createEntry({
        Container: BuyRespLayout,
        store,
        query: buyRespRootQuery,
    });
});
